export default {
  bg              : '#fff',
  fg              : '#333',
  border          : '#ccc',
  bgActive        : '#eee',
  bgHover         : '#ebebeb',
  primary         : '#038cfc',
  primaryActive   : '#027beb',
  primaryContrast : '#fff',
  error           : '#da0000',
  errorAlpha      : '#da000080',
  warning         : '#e48900',
  cookiesAlertBg  : '#ffdf70',
};
